module.exports = __webpack_public_path__ + "img/logo - copia.70d33eb3.png";